import { useLocation } from "react-router-dom";
import "../assets/styles/singleBlog.scss"
import BlogPosts from "../components/BlogPosts";
import Header from "../components/Header";
import { useEffect, useState } from "react";
import Footer from "../components/Footer";

function SingleBlog() {
  const location = useLocation();
  const blog = location.state?.blog;
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount

  }, []);
  return (
       <div className="single-blog-container">
        <Header/>
    <div className="main-container">

       <div className="blog-content-container">
        <div className="blog-news-container">
          <h6>تازه‌ترین مطالب</h6>
          <BlogPosts type="list" postNums={5}/>
        </div>

        <div className="post-content-container">
          <h3>{blog.title}</h3>
          <div className="post-info-container">
            <span>{blog.date}</span>
            <div className="post-tag">{blog.tag}</div>
          </div>

          <img className="post-main-img" src={blog.img} alt={blog.title}/>

          <p>{blog.desc}</p>
        </div>
  
       </div>

       <div className="related-news">
        <h5 className="related-title">مطالب مرتبط</h5>
        
        <BlogPosts postNums={3}/>
       </div>
    </div>

    <Footer/>
    </div>
  );
}

export default SingleBlog;
